/**
 * @param {string} orderStatus
 * @return {boolean}
 */
export const isOrderPending = (orderStatus) => {
  switch (orderStatus) {
    case 'completedOnline':
    case 'completedCash':
    case 'cashMarked':
    case 'paidOnline':
    case 'rejected':
    case 'prepaidDeliveryCompleted':
    case 'prepaidPickupCompleted':
    case 'prepaidPickupReady':
    case 'prepaidDeliveryReady':
    case 'markReady':
    case 'outForDelivery':
      return false;
    case 'new':
    case 'billSent':
    case 'sendBill':
      return true;
    default:
      return true;
  }
};
